import React from "react";
import "./PropertyJourneyTabs.scss";
import classNames from "classnames";
import { CommonEnums } from "../../../../../enums/common.enums";
import TrueIcon from "../../../../../components/icons/TrueIcon";

const PropertyJourneyTabs = ({
  activeTab,
  onTabChange,
}: {
  activeTab: string;
  onTabChange: (tab: string) => void;
}) => {
  const [completedSteps, setCompletedSteps] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (!completedSteps.includes(activeTab)) {
      setCompletedSteps((prev) => [...prev, activeTab]);
    }
  }, [activeTab]);

  const tabs = [
    {
      slug: CommonEnums.propertyPostJourney.property_info.key,
      label: CommonEnums.propertyPostJourney.property_info.value,
    },
    {
      slug: CommonEnums.propertyPostJourney.post_system.key,
      label: CommonEnums.propertyPostJourney.post_system.value,
    },
  ];

  const activeIndex = tabs.findIndex((tab) => tab.slug === activeTab);

  return (
    <div className="property-post-steps">
      {tabs.map((tab, index) => {
        const isActive = activeTab === tab.slug;
        const isCompleted = completedSteps.includes(tab.slug) && !isActive;

        const isDisabled =
          index > activeIndex && !completedSteps.includes(tab.slug);

        return (
          <div
            key={tab.slug}
            className={classNames("step-container", {
              "active-step": isActive,
              "completed-step": isCompleted,
              "disable-step": isDisabled,
            })}
            onClick={() => {
              if (!isDisabled) onTabChange(tab.slug);
            }}
          >
            {isCompleted && (
              <div className="icon-wrapper">
                <TrueIcon />
              </div>
            )}

            <span className="step-title">{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default PropertyJourneyTabs;
